import React from 'react';
import {classNames} from '@utils/class-names';
import AppMenu from "../app-menu";

interface MobileSidebarProps {
    isOpen: boolean;
    onClose: () => void;
}

const MobileSidebar: React.FC<MobileSidebarProps> = ({isOpen, onClose}) => {
    return (
        <>
            {isOpen && (
                <div
                    className="mobile-sidebar-overlay lg:hidden"
                    onClick={onClose}
                />
            )}

            <div
                className={classNames(
                    'mobile-sidebar lg:hidden mobile-menu-transition',
                    isOpen ? 'open' : ''
                )}
            >
                {isOpen && <AppMenu/>}
            </div>
        </>
    );
};

export default MobileSidebar;
